import Title from "../Title/Title";
import React from "react";
import { FaQuoteLeft } from 'react-icons/fa'
import Person from '../../assets/images/testimonial-1.jpg'

const Testimonial = () => {
  return (
    <>
      <Title title="testimonial" />
      <section className="testimonial">
        <div className="testimonial-card">
          <img
            src={Person}
            alt="alan doe"
            className="testimonial-banner"
            width="80"
            height="80"
          />

          <p className="testimonial-name">Alan Doe</p>

          <p className="testimonial-title">CEO & Founder Invision</p>

          <FaQuoteLeft className="quotation-img"/>

          <p className="testimonial-desc">
            Lorem ipsum dolor sit amet consectetur Lorem ipsum dolor dolor sit
            amet.
          </p>
        </div>
      </section>
    </>
  );
};

export default Testimonial;
